import { httpsCallable } from 'firebase/functions';
import { getFbFunctions } from './development';
import {
  updateDoc,
  doc,
  getDoc,
  getFirestore,
} from 'firebase/firestore';

import { getApp } from 'firebase/app';

export async function generateApiKey(): Promise<string | null> {
  const fbApp = getApp(this.firebaseApp);
  const functions = getFbFunctions(fbApp);

  try {
    const generate = httpsCallable(functions, 'auth-generateApiKey');
    return (await generate()).data as string;
  } catch {
    return null;
  }
}

export async function getApiAuthMethods() {
  const fbApp = getApp(this.firebaseApp);
  const db = getFirestore(fbApp, this.dbid);

  const docRef = doc(db, 'users', this.user.uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    if (docSnap.data().apiAuthMethods == null) {
      return 'none';
    } else {
      return docSnap.data().apiAuthMethods;
    }
  } else {
    return 'none';
  }
}

export async function changeApiAuthMethods(apiAuthMethods: string): Promise<boolean> {
  const fbApp = getApp(this.firebaseApp);
  const db = getFirestore(fbApp, this.dbid);

  try {
    await updateDoc(doc(db, 'users', this.user.uid), {
      apiAuthMethods: apiAuthMethods,
    });
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
}

export async function getApiKey(): Promise<string | null> {
  if (!this.user) {
    return null;
  }

  const fbApp = getApp(this.firebaseApp);
  const db = getFirestore(fbApp, this.dbid);

  const docRef = doc(db, 'users', this.user.uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    if (docSnap.data().apiKey == null) {
      return (await this.generateApiKey()) as string;
    } else {
      return docSnap.data().apiKey;
    }
  } else {
    return null;
  }
}

export async function getSearchKey(uid: string | undefined) {
  try {
    if (!uid) {
      return null;
    }

    const fbApp = getApp(this.firebaseApp);
    const functions = getFbFunctions(fbApp);
    const db = getFirestore(fbApp, this.dbid);

    const docRef = doc(db, 'users', uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      if (docSnap.data().algoliaKey == null) {
        const generate = httpsCallable(functions, 'search-generateUserKey');
        const key = await generate();
        if (key.data) {
          this.searchKey = key.data;
          return key.data;
        } else {
          return null;
        }
      } else {
        this.searchKey = docSnap.data().algoliaKey;
        return docSnap.data().algoliaKey;
      }
    } else {
      return null;
    }
  } catch {
    return null;
  }
}

export async function getTeamSearchKey() {
  try {
    const fbApp = getApp(this.firebaseApp);
    const functions = getFbFunctions(fbApp);
    const db = getFirestore(fbApp, this.dbid);

    if (this.team != null && this.userMode == 'team') {
      const docRef = doc(db, 'teams', this.team);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        if (docSnap.data().algoliaKey == null) {
          const generate = httpsCallable(functions, 'teams-generateAlgoliaTeamKey');
          const key = await generate({ teamId: this.team });
          if (key.data) {
            const teamData = this.teamData;
            teamData.searchKey = key.data;
            this.teamData = teamData;
            return key.data;
          } else {
            return null;
          }
        } else {
          const teamData = this.teamData;
          teamData.searchKey = docSnap.data().algoliaKey;
          this.teamData = teamData;
          return docSnap.data().algoliaKey;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch {
    return null;
  }
}
